import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

function ServiceCategory() {
  let navigate = useNavigate();

  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }
  const [blog, setBlog] = useState({
    select: "",
  });

  let name, value;
  const handleInputs = (e) => {
    console.log(e);
    name = e.target.name;
    value = e.target.value;
    setBlog({ ...blog, [name]: value });
  };
  const PostData = async (e) => {
    e.preventDefault();
    const { select } = blog;
    const res = await fetch("https://api.homedotapp.com/servicecategory", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        select: select,
      }),
    });
    const data = await res.json();
    if (data.status === 422 || !data) {
      window.alert("failed to add category");
    } else {
      window.alert("successfully added!");
    }
  };

  return (
    <div className="container-scroller">
      <Navbar />

      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        {/* partial */}
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row grid-margin">
              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Service Category</h4>
                    {/* <p className="card-description">Add New Blog</p> */}
                    <form className="forms-sample" onSubmit={PostData}>
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">
                          Profesional Category
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputUsername1"
                          placeholder="Professional category"
                          name="select"
                          value={blog.select}
                          onChange={handleInputs}
                        />
                      </div>
                      <button
                        type="submit"
                        onClick={PostData}
                        className="btn btn-primary me-2"
                      >
                        Submit
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServiceCategory;
